import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito experiencia previa en construcción?',
    a: 'No. El Mega Pack está diseñado desde cero para personas sin experiencia técnica. Cada concepto se explica con lenguaje claro, proporciones exactas y ejemplos de campo. Si podés seguir una receta, podés construir con este sistema.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Es un pack digital (PDF de alta calidad). Lo recibís en tu email de forma inmediata después del pago. Podés verlo en celular, tablet o computadora y llevarlo directamente a la obra.'
  }, {
    q: '¿Funciona para mi zona climática?',
    a: 'Sí. El Tomo 1 incluye un capítulo completo de adaptación climática. Cubrimos climas áridos, húmedos, fríos y templados con técnicas específicas para cada uno. Argentina, Uruguay, Chile y toda Latinoamérica.'
  }, {
    q: '¿La tierra de mi terreno sirve?',
    a: 'El Test del Frasco del Tomo 1 te dirá exactamente si tu tierra es apta en menos de 24 horas. Y si no lo es, te enseñamos cómo "corregirla" añadiendo arena o arcilla hasta la proporción perfecta.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si abrís los tomos y sentís que no es lo que esperabas, te devolvemos el 100% sin preguntas, sin formularios y sin demoras. Nuestra tasa de devolución es menor al 1%.'
  }, {
    q: '¿El precio de $19.999 es permanente?',
    a: 'No. Es un precio exclusivo de lanzamiento. Cuando se agoten los cupos o finalice el contador, el precio sube $8.000 ARS y no vuelve al valor actual. No hay fecha de reapertura confirmada.'
  }];
  return <section className="bg-[#F5F5EB] py-20 px-5 text-center" data-id="element-75" data-mp="2jg58524drdnu">
      <h2 className="text-[clamp(22px,3.5vw,36px)] text-[#1A1A1A] mb-10" data-id="element-76" data-mp="u1gtsvc8bln6">
        ❓ Lo que más nos preguntan
      </h2>

      <div className="max-w-[680px] mx-auto text-left" data-id="element-77" data-mp="p2vtyx0w33z9">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl mb-3 overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.04)]" data-id="element-78" data-mp="2p4ltfp0i7ke7" data-mpi={index}>
            <div className="py-[18px] px-[22px] text-[15px] font-bold text-[#1A1A1A] font-sans flex justify-between items-center cursor-pointer gap-3" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-79" data-mp="2u36u1pjo4636">
              {faq.q}
              <motion.span className="text-[22px] text-brown-light shrink-0 font-light" animate={{
            rotate: openIndex === index ? 45 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-80" data-mp="382pstrqla52t">
                +
              </motion.span>
            </div>
            <AnimatePresence data-id="element-81" data-mp="3huc9w4plyydh">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-82" data-mp="3mqavxlngs4aq">
                  <div className="px-[22px] pb-[18px] text-sm text-[#555] font-sans leading-[1.7]" data-id="element-83" data-mp="1k5qd0l3hr60y">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
};